module.exports = __webpack_public_path__ + "static/media/About-VR.d0641a84.png";